class WebSocketManager {
    private socket: WebSocket;
    private isConnected: boolean = false;
  
    connect(url: string, token: string) {

      const urlFinal = `${url.replace('http', 'ws')}?token=${token}`;
      this.socket = new WebSocket(urlFinal);
  
      this.socket.onopen = () => {
        this.isConnected = true;
      };
  
      this.socket.onclose = () => {
        this.isConnected = false;
      };
  
      this.socket.onerror = (error) => {
        console.error('WebSocket Error', error);
      };
    }
  
    disconnect() {
      if (this.socket && this.isConnected) {
        this.socket.close();
        this.socket = null as any;
        this.isConnected = false;
      }
    }
  
    sendMessage(message: string) {
      if (this.socket && this.isConnected) {
        this.socket.send(message);
      }
    }

    registerMessageHandler(handler) {
      this.socket.addEventListener('message', (event) => {
        handler(event.data);
      });
    }
  }
  
  export default WebSocketManager;
  